import { useState, useEffect } from "react";
import { isMobileScreen } from "@/utils/functions";
import Image from "@/atoms/Image";
import H2 from "@/atoms/text/H2";
import Label from "@/atoms/text/Label";
import { AestheticBg1, AestheticBg2, AestheticBg3 } from "@/atoms/Icons";

export default function BadgeSection({
  label,
  title,
  bgColor,
  image,
  hasAestheticBg,
}) {
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  return (
    <section className={`bc-${bgColor} pv-10-d pv-8 ps-r aestheticBg`}>
      <div className="container">
        <div
          className={`fx fx--c fx--r-d fx--ch-d fx--cv ${
            isMobile ? "inset-both-sm ta-center" : ""
          }`}
        >
          {label && isMobile && (
            <Label size="xxl" color="blue-light" className="bold mb-5">
              {label}
            </Label>
          )}
          {image && (
            <Image
              fileName={image.fileName}
              fileFormat="png"
              desktopWidth={image.desktopWidth}
              mobileWidth={image.mobileWidth}
              alt={image.altText}
              isBannerImg={false}
              has2XWebp
              className={`${isMobile ? "mb-5" : ""}`}
            />
          )}
          <article className="content-wrapper ml-7-d">
            {label && !isMobile && (
              <Label size="xxl" color="blue-200" className="bold mb-1">
                {label}
              </Label>
            )}
            {title && (
              <H2
                mobileSize="lg"
                className="bold"
                color="white"
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
          </article>
        </div>
      </div>
      {hasAestheticBg && (
        <>
          {isMobile ? (
            <AestheticBg3 className="aestheticBg-right" />
          ) : (
            <>
              <AestheticBg1 className="aestheticBg-left" />
              <AestheticBg2 className="aestheticBg-right" />
            </>
          )}
        </>
      )}
    </section>
  );
}
